import Step1_Gender from '../../components/master/demographics/steps/Gender';
import Step2_DOB from '../../components/master/demographics/steps/DOB';
import Step3_HeightWeight from '../../components/master/demographics/steps/HeightWeight';
import Step4_BloodPressure from '../../components/master/demographics/steps/BloodPressure';

const configA = [Step1_Gender, Step2_DOB, Step3_HeightWeight, Step4_BloodPressure];

export default configA;
